import React, { useEffect, useRef } from 'react';
import { DISCOUNTS_ENABLED } from '../content/features';
import './WelcomeModal.css';

export default function WelcomeModal({ onClose, firstName }) {
  const overlayRef = useRef(null);

  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  function handleOverlayClick(e) {
    if (e.target === overlayRef.current) onClose();
  }

  return (
    <div
      className="welcome-overlay"
      ref={overlayRef}
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="welcome-title"
    >
      <div className="welcome-modal">
        <button className="welcome-modal__close" onClick={onClose} aria-label="Close">×</button>

        <img src="/assets/logo.png" alt="Volcyy" className="welcome-modal__logo" />

        <h2 id="welcome-title" className="welcome-modal__title">
          Welcome{firstName ? `, ${firstName}` : ''}!
        </h2>
        <p className="welcome-modal__sub">
          {DISCOUNTS_ENABLED
            ? "You're all set! Browse venues worldwide, unlock exclusive discounts at participating locations, and enjoy it all for free."
            : "You're all set! Find venues near you, read what people are really saying, and join the conversation."}
        </p>

        <button className="welcome-modal__cta" onClick={onClose}>
          Start Browsing
        </button>
      </div>
    </div>
  );
}
